import { Directive, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const patten = new RegExp(/0[127]\d{8,9}/);
    return (!control.value || patten.test(control.value)) ? null : { validPhoneNumber: { value: control.value } };
  };
}

@Directive({
  selector: '[validPhoneNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidPhoneNumberDirective, multi: true }]
})
export class ValidPhoneNumberDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } {
    return phoneNumberValidator()(control);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/shared/valid-phone-number.directive.ts